import { render, staticRenderFns } from "./VisitHistory.vue?vue&type=template&id=4c76e94b&scoped=true&"
import script from "./VisitHistory.ts?vue&type=script&lang=ts&"
export * from "./VisitHistory.ts?vue&type=script&lang=ts&"
import style0 from "./VisitHistory.scss?vue&type=style&index=0&id=4c76e94b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c76e94b",
  null
  
)

export default component.exports